// export const BASE_URL = 'https://api-olarms.ogunstate.gov.ng/api';
export const BASE_URL = 'https://api.ogswc.ogunstate.gov.ng/api';